import { addCollection } from '@iconify/vue'
import mdi from '@iconify-json/mdi/icons.json'

addCollection(mdi)